import React, { useCallback, useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import apiService from "../../services/api.service";
import "./eventChat.css";

const CHAT_REFRESH_MS = 3000;

const EventChat = ({ eventId }) => {
  const [chat, setChat] = useState(null);
  const [body, setBody] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const messagesRef = useRef(null);

  const load = useCallback(async () => {
    try {
      const response = await apiService.getMyEventChat(eventId);
      setChat(response.data);
      setError("");
    } catch {
      setError("Impossibile aggiornare la chat.");
    }
  }, [eventId]);

  useEffect(() => {
    load();
    const interval = setInterval(load, CHAT_REFRESH_MS);
    return () => clearInterval(interval);
  }, [load]);

  useEffect(() => {
    const element = messagesRef.current;
    if (element) element.scrollTop = element.scrollHeight;
  }, [chat?.messages?.length]);

  const send = async (event) => {
    event.preventDefault();
    const message = body.trim();
    if (!message || sending) return;
    setSending(true);
    setError("");
    try {
      const response = await apiService.sendEventChatMessage(eventId, message);
      setChat(response.data);
      setBody("");
    } catch (err) {
      setError(err.response?.data?.detail || "Invio del messaggio non riuscito.");
      await load();
    } finally {
      setSending(false);
    }
  };

  const canWrite = chat?.can_write !== false;

  return (
    <aside className="event-chat" aria-label="Chat evento">
      <div className="event-chat__header">
        <h2>Chat evento</h2>
        <span className="event-chat__status">In diretta</span>
      </div>
      <p className="event-chat__intro">Scrivi una domanda.</p>
      <div className="event-chat__messages" ref={messagesRef} aria-live="polite">
        {chat?.messages?.length ? chat.messages.map((message) => (
          <div
            key={message.id}
            className={`event-chat__message${message.sender_role === "gestore" ? " event-chat__message--manager" : ""}`}
          >
            <strong>{message.sender_role === "gestore" ? "Gestore" : "Tu"}</strong>
            <p>{message.body}</p>
            <time>{new Date(message.created_at).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</time>
          </div>
        )) : (
          <p className="event-chat__empty">Nessun messaggio. Inizia la conversazione.</p>
        )}
      </div>
      {error && <p className="event-chat__error" role="alert">{error}</p>}
      {canWrite ? (
        <Form onSubmit={send} className="event-chat__form">
          <Form.Control
            as="textarea"
            rows={2}
            maxLength={4000}
            value={body}
            onChange={(event) => setBody(event.target.value)}
            placeholder="Scrivi il tuo messaggio..."
            aria-label="Messaggio per il gestore"
          />
          <Button type="submit" disabled={sending || !body.trim()}>
            {sending ? "Invio..." : "Invia"}
          </Button>
        </Form>
      ) : (
        <p className="event-chat__closed">La chat è stata terminata e non accetta nuovi messaggi.</p>
      )}
    </aside>
  );
};

export default EventChat;
